import React, { Component } from "react";
import  BootstrapTable  from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { connect } from "react-redux";
import {
    Card, CardBody, Pagination
} from 'reactstrap';
import {LoadingDone,Loading,Success,Error,Reset, SetCompanySearchResult, SetSelectedCompany } from "../../../actions/loading";


class SearchCompanyGrid extends Component {
    constructor(...args) {
        super(...args);

    }
    selectRow = {
        mode: 'radio',
        clickToSelect: true,
        hideSelectColumn: true,
        onSelect: (row, isSelect, rowIndex, e) => {
            this.props.SetSelectedCompany(row);
        }
    };

    render() {
        return (
            <Card className="w-100">
                <CardBody>
                 <BootstrapTable
                 striped
                 data={this.props.searchcompanydata.data}
                 columns={this.props.OrderColumns}
                 keyField="id"
                 selectRow={this.selectRow}
                /> 
                </CardBody>
            </Card>

            );
    }
}

var cpf = connect(state => ({
    loading : state.loading,
    searchcompanydata : state.SearchCompany
}),{SetSelectedCompany})(SearchCompanyGrid);    
export default cpf;